import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";


// OBSOLETE
// TER DRAFTEL CODECS LIB

/*
// OBSOLETE
// PPGRUPA RMT - VAZNO NE KORISTI SE OVAJ klizacramamraztermostata jer je on sada u sastavu PPGRUPA RMT

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_klizacramamraztermostata',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$klizacramamraztermostata');
};


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_klizacramamraztermostata_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima

};


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$klizacramamraztermostata');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  const klizacramamraztermostataNaziv = '? Klizac rama mraz termostata ?';
  p.naziv = klizacramamraztermostataNaziv;
  //
  const _params = {
    "operacija": "OPSKL",
    "rc": "RCDE",
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$klizacramamraztermostata',
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$klizacramamraztermostata") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


/////////


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(elk_raw => {
      let draftel_elk = {
        ...draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_preset_state(),
        ...elk_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(draftel_elk);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$klizacramamraztermostata');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  const paired_virtel = draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.bundleDrafel_to_paired_virtel(bundleDraftel);

  const local_graphlevel = 1;
  _virbom_manipulator.add_as_first_virtel(virbom_ref, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  // let pods_input_za_derivate = derAutoCreateVirbom_terkk_klizacramamraztermostata_prepare_vir_input(paired_virtel); // ??? 
  // let _der_virtel_children = derAutoCreateVirbom_terkk_klizacramamraztermostata_children(pods_input_za_derivate);
  let _der_virtel_children = [];
  console.log('_der_virtel_children', _der_virtel_children);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3
  // ***ZAVRSENI KORACI ZA JEDAN pp3

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING


/*
draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_klizacramamraztermostata.keys_for_direct_cloning)
  };
  //
  return state;
};
*/

